import React from 'react';
import { motion } from 'framer-motion';
import { FaRobot } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { getWhatsAppUrl } from '../content/site-info';

const FAQSection = () => {
  return (
    <section className="section-padding bg-gradient-to-b from-gray-50 to-white dark:from-gray-950 dark:to-gray-900">
      <div className="container-responsive">
        {/* CTA Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="mt-6 xs:mt-8 sm:mt-10 md:mt-12"
        >
          <div className="bg-gradient-to-r from-primary-50 to-primary-100 dark:from-primary-950 dark:to-primary-900
                        rounded-2xl p-6 xs:p-8 sm:p-10 md:p-12 border border-primary-200 dark:border-primary-800
                        text-center">
            <div className="flex items-center justify-center gap-3 mb-4">
              <FaRobot className="w-6 h-6 xs:w-8 xs:h-8 text-primary-600" />
              <h3 className="text-xl xs:text-2xl sm:text-3xl md:text-4xl font-bold 
                           text-gray-800">
                Ainda tem dúvidas?
              </h3>
            </div>
            <p className="text-sm xs:text-base sm:text-lg text-gray-600 mb-6 xs:mb-8 
                         max-w-2xl mx-auto">
              Nossa equipe está pronta para ajudar! Use o chatbot no canto inferior 
              esquerdo ou entre em contato conosco pelo WhatsApp.
            </p>
            <div className="flex flex-col xs4:flex-row gap-3 xs:gap-4 justify-center 
                          items-center">
              <motion.button
                onClick={() => {
                  // Abrir o chatbot - procura pelo botão do chatbot
                  const chatbotButton = document.querySelector('[aria-label*="Abrir chat"], [aria-label*="Fechar chat"]');
                  if (chatbotButton) {
                    chatbotButton.click();
                    // Scroll suave até o chatbot
                    setTimeout(() => {
                      chatbotButton.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                    }, 100);
                  }
                }}
                className="btn-primary text-sm xs:text-base sm:text-lg px-6 xs:px-8 
                          sm:px-10 py-3 xs:py-3.5 sm:py-4 w-full xs4:w-auto min-h-12 
                          inline-flex items-center justify-center gap-2 whitespace-nowrap"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                transition={{ type: "spring", stiffness: 400, damping: 17 }}
              >
                <FaRobot className="w-5 h-5 animate-pulse" />
                Chatbot
              </motion.button>
              <motion.a
                href={getWhatsAppUrl('Olá! Tenho uma dúvida sobre os serviços da Notemaster.')}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-secondary text-sm xs:text-base sm:text-lg px-6 xs:px-8 
                          sm:px-10 py-3 xs:py-3.5 sm:py-4 w-full xs4:w-auto min-h-12 
                          inline-flex items-center justify-center gap-2 whitespace-nowrap"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                transition={{ type: "spring", stiffness: 400, damping: 17 }}
              >
                <svg 
                  xmlns="http://www.w3.org/2000/svg" 
                  className="w-5 h-5 animate-pulse" 
                  fill="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path d="M20.52 3.48A11.93 11.93 0 0012 0C5.37 0 .01 5.37.01 12c0 2.11.55 4.17 1.6 6L0 24l6.17-1.61a11.94 11.94 0 005.83 1.49c6.63 0 12-5.37 12-12 0-3.19-1.24-6.19-3.48-8.52zM12 22c-1.8 0-3.56-.47-5.11-1.36l-.37-.22-3.66.96.98-3.57-.24-.37A9.94 9.94 0 012.01 12C2.01 6.48 6.48 2 12 2s9.99 4.48 9.99 10S17.52 22 12 22zm5.27-7.4c-.29-.15-1.7-.84-1.96-.94-.26-.1-.45-.15-.64.15-.19.29-.74.94-.91 1.13-.17.19-.34.21-.63.07-.29-.15-1.23-.45-2.34-1.43-.86-.77-1.44-1.72-1.61-2.01-.17-.29-.02-.45.13-.6.13-.13.29-.34.43-.51.14-.17.19-.29.29-.48.1-.19.05-.36-.02-.51-.07-.15-.64-1.54-.88-2.11-.23-.56-.47-.48-.64-.48h-.55c-.19 0-.48.07-.73.36-.26.29-1 1-1 2.43s1.02 2.82 1.16 3.01c.14.19 2.01 3.07 4.87 4.3.68.29 1.21.46 1.62.59.68.22 1.3.19 1.79.12.55-.08 1.7-.7 1.94-1.38.24-.68.24-1.26.17-1.38-.07-.12-.26-.19-.55-.34z" />
                </svg>
                WhatsApp
              </motion.a>
            </div>
            <p className="mt-6 xs:mt-8 text-xs xs:text-sm text-gray-500">
              Ou acesse nossa <Link to="/contato" className="text-primary-600 
              hover:text-primary-700 underline font-semibold">página de contato</Link> 
              para mais informações
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default FAQSection;

